import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {Formulario} from "../../../modelos/formulario";
import {Path} from "../../../util/path";
import {ActivatedRoute} from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-canal-gams',
    templateUrl: './canal-gams.component.html',
    styleUrls: ['./canal-gams.component.scss'],
    standalone: false
})
export class CanalGamsComponent implements OnInit {

  formulario!: UntypedFormGroup;
  formularioData!: Formulario;
  pathGams: Path = Path.COMISSAO_GAMS;
  pathCanal: Path = Path.COMISSAO_GAMS_CANAL_ACOLHIMENTO;
  listaPaginas: any;
  loading = false;
  successMessage = '';
  errorMessage = '';

  tipoMensagem: string[] = [
    'Reclamação',
    'Informação',
    'Solicitação',
    'Sugestão',
    'Outra'
  ];

  tipoPrivacidade: string[] = [
    'A comissão pode ter acesso aos meus dados pessoais.',
    'Desejo que meus dados pessoais sejam mantidos sob sigilo.'
  ];

  tipoContato: string[] = [
    'Desejo receber contato de retorno.',
    'Não desejo receber contato de retorno.'
  ];

  constructor(
    protected rotaAtiva: ActivatedRoute,
    readonly cdr: ChangeDetectorRef,
    readonly fb: UntypedFormBuilder,
    readonly http: HttpClient
  ) { }

  ngOnInit(): void {
    this.formularioData = {
      nome: '',
      nomeSocial: '',
      sigiloDados: false,
      email: '',
      telefone: '',
      tipo: '',
      mensagem: '',
      contatoRetorno: false,
      comissao: 'denuncias.violenciadomestica@jfrn.jus.br'
    };
    this.initForm();
    this.rotaAtiva.data.subscribe(data => {
      this.listaPaginas = data;
    });
  }

  initForm() {
    this.formulario = this.fb.group({
      nome: ['', Validators.required],
      nomeSocial: [''],
      email: ['', Validators.required],
      telefone: ['', Validators.required],
      mensagem: ['', Validators.required],
      contatoRetorno: ['Desejo receber contato de retorno.', Validators.required],
      anonimato: ['A comissão pode ter acesso aos meus dados pessoais.', Validators.required],
      tipoMensagem: ['Reclamação', Validators.required]
    });
  }

  private markAllFieldsAsTouchedAndShowErrorMessage(): void {
    this.formulario.markAllAsTouched();
  }

  onSubmit(): void {
    if (!this.formulario.valid) {
      this.markAllFieldsAsTouchedAndShowErrorMessage();
      return;
    }
    this.tratarFormulario();
    this.enviarEmail();
    this.limparFormulario();
  }

  limparFormulario() {
    this.formulario = this.fb.group({
      nome: ['', Validators.required],
      nomeSocial: [''],
      email: ['', Validators.required],
      telefone: ['', Validators.required],
      mensagem: ['', Validators.required],
      contatoRetorno: ['Desejo receber contato de retorno.', Validators.required],
      anonimato: ['A comissão pode ter acesso aos meus dados pessoais.', Validators.required],
      tipoMensagem: ['Denúncia', Validators.required]
    });

    this.formularioData = {
      nome: '',
      nomeSocial: '',
      sigiloDados: false,
      email: '',
      telefone: '',
      tipo: '',
      mensagem: '',
      contatoRetorno: false,
      comissao: 'denuncias.violenciadomestica@jfrn.jus.br'
    };
  }

  tratarFormulario() {
    const contatoRetorno = this.formulario.value.contatoRetorno === 'Desejo receber contato de retorno.';

    this.formularioData = {
      nome: this.formulario.value.nome,
      nomeSocial: this.formulario.value.nomeSocial || '',
      email: this.formulario.value.email,
      telefone: this.formulario.value.telefone,
      tipo: this.formulario.value.tipoMensagem,
      mensagem: this.formulario.value.mensagem,
      sigiloDados: false,
      contatoRetorno,
      comissao: 'denuncias.violenciadomestica@jfrn.jus.br'
    };
  }

  enviarEmail() {
    this.loading = true;
    this.successMessage = '';
    this.errorMessage = '';

    const url = `${environment.apiGateway}atom-notificacao-service/v1/external/notification/emailFormulario`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    this.http.post(url, this.formularioData, { headers }).subscribe(
      (response: any) => {
        this.loading = false;
        this.successMessage = 'Mensagem enviada com sucesso!';
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.loading = false;
        this.errorMessage = 'Erro ao enviar mensagem, tente novamente mais tarde.';
        console.error('Erro ao enviar email:', error);
      }
    );
  }

}
